<template>
  <mp-flex :margin-right="!withChild && ['0px', '60px']">
    <mp-box
      max-height="calc(100vh - 60px)"
      :border-right="
        isToggle ? (isStacked ? (withChild ? '1px' : '0px') : withChild ? '1px' : '0px') : isStacked ? (withChild ? '1px' : '0px') : '0px'
      "
      border-color="gray.100"
      transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
      :background-color="withChild ? 'ash.100' : 'background'"
      :position="isStacked ? 'relative' : 'absolute'"
      :width="isToggle ? '3.75rem' : '13.5rem'"
      :max-width="isToggle ? '3.75rem' : '13.5rem'"
      :display="['none', 'block']"
      margin-right="-60px"
      z-index="99"
      :box-shadow="
        isToggle
          ? isStacked
            ? withChild
              ? 'lg'
              : 'none'
            : isChildToggle
            ? 'none'
            : 'lg'
          : isStacked
          ? withChild
            ? isChildToggle
              ? 'none'
              : 'lg'
            : 'none'
          : 'lg'
      "
    >
      <mp-box
        as="section"
        class="sidebar-content"
        data-id="sidebar"
        width="full"
        height="calc(100vh - 60px)"
        overflow-y="auto"
        overflow-x="hidden"
        padding-top="4"
        padding-x="2"
        padding-bottom="60px"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <mp-box>
          <template v-for="(parentMenu, idx) in menus">
            <!-- eslint-disable-next-line -->
            <mp-box v-if="parentMenu.isShow" :key="idx" :_notLast="{ borderBottom: '1px solid #D0D6DD' }" py="3">
              <mp-text v-if="parentMenu.title" px="3" py="2">
                <mp-tooltip position="right" :label="parentMenu.title" :visibility="isToggle || parentMenu.isTooltip ? 'visible' : 'hidden'">
                  <mp-box>
                    <mp-icon v-if="isToggle" name="menu-meatball" color="gray.400" />
                    <mp-stack v-else direction="row" align="center">
                      <mp-text
                        as="span"
                        font-weight="bold"
                        letter-spacing="3px"
                        font-size="sm"
                        color="gray.600"
                        text-transform="uppercase"
                        line-height="25px"
                      >
                        {{ parentMenu.title }}
                      </mp-text>
                    </mp-stack>
                  </mp-box>
                </mp-tooltip>
              </mp-text>
              <template v-for="menu in parentMenu.items">
                <!-- eslint-disable vue/attribute-hyphenation -->
                <mp-flex v-if="menu.isShow" :key="menu.id" :data-qa="`component-sidebar-menu-item-${menu.id}`" flex-direction="column">
                  <mp-popover v-if="menu.children" trigger="hover" placement="right-start" is-force-update-popper close-on-select>
                    <mp-popover-trigger :data-qa="menu.dataQA">
                      <router-link v-slot="{ href, navigate }" :to="menu.link">
                        <a :href="href" @click="navigate">
                          <mp-flex flex-direction="column">
                            <mp-pseudo-box
                              role="group"
                              flex="1"
                              border-radius="md"
                              transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                              padding-x="2.5"
                              padding-y="2"
                              :background-color="menu.isActive ? 'blue.100' : 'inherit'"
                              :color="menu.isActive ? 'blue.400' : 'inherit'"
                            >
                              <mp-stack
                                direction="row"
                                justify="space-between"
                                align="center"
                                :_groupHover="{
                                  cursor: 'pointer',
                                }"
                              >
                                <mp-flex gap="2">
                                  <mp-icon
                                    :name="menu.icon"
                                    :variant="menu.isActive ? 'fill' : 'outline'"
                                    :color="menu.isActive ? 'blue.400' : 'gray.600'"
                                    :_groupHover="{
                                      color: 'blue.400',
                                    }"
                                  />
                                  <mp-text
                                    white-space="nowrap"
                                    :font-weight="menu.isActive ? 'semibold' : 'inherit'"
                                    :color="menu.isActive ? 'blue.400' : 'dark'"
                                    :opacity="isToggle ? '0' : '1'"
                                    :_groupHover="{
                                      color: 'blue.400',
                                    }"
                                  >
                                    {{ menu.name }}
                                  </mp-text>
                                </mp-flex>
                                <mp-icon
                                  name="chevrons-right"
                                  size="sm"
                                  :color="menu.isActive ? 'blue.400' : 'gray.600'"
                                  :_groupHover="{
                                    color: 'blue.400',
                                  }"
                                />
                              </mp-stack>
                            </mp-pseudo-box>
                          </mp-flex>
                        </a>
                      </router-link>
                    </mp-popover-trigger>
                    <mp-popover-content
                      v-pixel="{
                        marginTop: '-10px !important',
                      }"
                      gutter="13"
                      min-width="194px"
                      background-color="overlayFill"
                      box-shadow="lg"
                      border-radius="md"
                      class="child-menu"
                    >
                      <mp-popover-list>
                        <template v-for="child in menu.children">
                          <mp-pseudo-box
                            v-if="!child.isHidden"
                            :key="child.id"
                            :data-qa="`component-sidebar-menu-child-${child.id}`"
                            :to="child.link"
                            as="router-link"
                            width="full"
                          >
                            <mp-popover-list-item
                              white-space="nowrap"
                              :is-active="child.isActive"
                              :color="child.isActive ? 'white' : 'white'"
                              :background-color="child.isActive ? 'blue.400' : 'transparent'"
                              :_hover="{
                                backgroundColor: 'blue.400',
                                color: 'white',
                                cursor: 'pointer',
                              }"
                              transition="all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                              :data-qa="child.dataQA"
                            >
                              {{ child.name }}
                              <mp-badge v-if="child.badge" display="block" variant-color="red" text-align="center" line-height="14px">{{
                                child.badge
                              }}</mp-badge>
                            </mp-popover-list-item>
                          </mp-pseudo-box>
                        </template>
                      </mp-popover-list>
                    </mp-popover-content>
                  </mp-popover>

                  <router-link v-else v-slot="{ href, navigate, isActive }" :to="menu.link">
                    <a :href="href" :data-qa="menu.dataQA" @click="navigate">
                      <mp-pseudo-box
                        role="group"
                        flex="1"
                        border-radius="md"
                        transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                        padding-x="2.5"
                        padding-y="2"
                        :background-color="isActive ? 'blue.100' : 'inherit'"
                        :color="isActive ? 'blue.400' : 'inherit'"
                      >
                        <mp-stack direction="row" align="start" position="relative">
                          <mp-icon
                            :name="menu.icon"
                            :variant="isActive ? 'fill' : 'outline'"
                            :color="isActive ? 'blue.400' : 'gray.600'"
                            :_groupHover="{
                              color: 'blue.400',
                              cursor: 'pointer',
                            }"
                          />
                          <mp-text
                            v-if="!isToggle"
                            :font-weight="isActive ? 'semibold' : 'inherit'"
                            :color="isActive ? 'blue.400' : 'dark'"
                            :opacity="isToggle ? '0' : '1'"
                            :_groupHover="{
                              color: 'blue.400',
                              cursor: 'pointer',
                            }"
                          >
                            {{ menu.name }}
                          </mp-text>
                          <!-- eslint-enable -->
                          <mp-flex v-if="menu.badge" h="6" align="center" ml="auto">
                            <mp-badge v-if="!isToggle" display="block" variant-color="red" text-align="center" line-height="14px">{{
                              menu.badge
                            }}</mp-badge>
                            <mp-box
                              v-else-if="menu.isNotifBadge"
                              position="absolute"
                              right="-4px"
                              top="-3px"
                              bg="rose.400"
                              w="14px"
                              h="14px"
                              border-radius="full"
                              border="2px solid #E7EDF5"
                            />
                          </mp-flex>
                        </mp-stack>
                      </mp-pseudo-box>
                    </a>
                  </router-link>
                </mp-flex>
                <!-- eslint-enable vue/attribute-hyphenation -->
              </template>
            </mp-box>
          </template>
        </mp-box>
        <mp-flex
          gap="2"
          :background-color="withChild ? 'ash.100' : 'background'"
          flex-direction="row"
          align-items="center"
          position="absolute"
          border-top="1px solid"
          border-color="gray.100"
          bottom="0"
          left="0"
          right="0"
          padding="2"
          width="100%"
        >
          <mp-tooltip
            position="right"
            :show-delay="200"
            :label="!isForced ? 'Click to expand or shortcut [shift] + [x]' : 'Click to collapse or shortcut [shift] + [x]'"
            use-portal
          >
            <mp-pseudo-box
              role="group"
              border-radius="sm"
              transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
              padding-x="2.5"
              padding-y="2"
              :_hover="{
                backgroundColor: 'blue.100',
                color: 'blue.400',
                cursor: 'pointer',
              }"
              @click="handleToggle"
            >
              <mp-stack direction="row" align="center">
                <mp-icon :name="!isForced ? 'arrow-expand' : 'arrow-collapse'" size="sm" />
              </mp-stack>
            </mp-pseudo-box>
          </mp-tooltip>
          <mp-text v-if="!isToggle && cid !== 1849" font-size="sm" color="dark" white-space="nowrap" :opacity="isToggle ? '0' : '1'" is-truncated>
            Company ID : {{ cid }}
          </mp-text>
        </mp-flex>
      </mp-box>
    </mp-box>
    <pixel-sidebar-child v-if="withChild" :data="subMenus" @toggle="handleChildToggle" />
  </mp-flex>
</template>

<script>
import PixelSidebarChild from '@/components/layouts/SidebarChild';
import roleMixin from '@/mixins/role';

export default {
  name: 'PixelSidebarNew',
  components: {
    PixelSidebarChild,
  },
  mixins: [roleMixin],
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    isAlternate: {
      type: Boolean,
      default: true, // default for performance review
    },
    isCustom: {
      type: Boolean,
      default: true, // default for performance review
    },
  },
  data() {
    return {
      isStacked: false,
      isToggle: this.isCollapsed,
      isForced: this.isAlternate || false,
      isChildToggle: true,
      isHovered: 0,
      canAccessGoalReport: false,
      canAccessCalibration: false,
      preventHover: false,
    };
  },
  watch: {
    $route() {
      // To prevent showing sidebar; because when move to other page (by clicking menu) will be considered as hover and it will show the sidebar
      this.handleMouseLeave();
      this.preventHover = true;

      // To set collapse/expand sidebar, force collapse/expand button & stack
      this.isToggle = this.defaultIsToggle ? true : this.isToggle;
      this.isForced = this.defaultIsToggle ? false : this.isForced;
      this.isStacked = this.defaultIsToggle ? false : this.isStacked;
    },
  },
  computed: {
    defaultIsToggle() {
      return this.withChild || false;
    },
    withChild() {
      if (['/home', '/reviews/overview'].some(slug => this.$route.path.includes(slug))) return false;
      return Boolean(this.subMenus);
    },
    isTalentsPages() {
      return ['/succession-plan/', '/competency-management/', '/individual-development-plan/'].some(slug => this.$route.path.includes(slug));
    },
    isKakiTangan() {
      return this.$store.state.isKakiTangan;
    },
    menus() {
      return [
        {
          isShow: true,
          items: [
            {
              id: 1,
              name: 'Home',
              icon: 'home',
              link: { name: 'home' },
              isShow: !this.isSuperAdmin || this.isOwnCompany,
              dataQA: 'sidebar-menu-home',
            },
            {
              id: 2,
              name: 'Dashboard',
              icon: 'dashboard',
              link: { name: 'review_overview' },
              isShow: this.isSuperAdmin,
              dataQA: 'sidebar-menu-reviews-overview',
            },
            {
              id: 3,
              name: 'Reports',
              icon: 'reports',
              link: { name: 'reports_index' },
              isShow: this.isSuperAdmin || this.hasAccess('review-cycle.report') || this.canAccessGoalReport,
              dataQA: 'sidebar-menu-reports',
            },
          ],
        },
        {
          isShow: true,
          items: [
            {
              id: 41,
              name: 'Reviews',
              icon: 'performance',
              link: { name: 'reviews' },
              isShow: true,
              dataQA: 'sidebar-menu-reviews',
              children: [
                {
                  id: 411,
                  name: 'Pending action',
                  link: { name: 'performance_review_root' },
                  badge: this.$store.getters.getSidebarNotif('pending_action'),
                  dataQA: 'sidebar-menu-reviews-performance-review',
                },
                {
                  id: 412,
                  name: 'Review cycles',
                  link: { name: 'review_cycle_list' },
                  isHidden: !(this.isSuperAdmin || this.hasAccess('review-cycle')),
                  dataQA: 'sidebar-menu-reviews-review-cycle',
                },
                {
                  id: 413,
                  name: 'My reviews',
                  link: { name: 'performance_review_my_review' },
                  dataQA: 'sidebar-menu-reviews-my-review',
                },
                {
                  id: 414,
                  name: 'Calibrations',
                  link: { name: 'calibration_list' },
                  dataQA: 'sidebar-menu-reviews-calibration',
                  isHidden: !this.isSuperAdmin && !this.canAccessCalibration,
                },
              ],
            },
            {
              id: 51,
              name: 'Goals',
              icon: 'goal',
              link: { name: 'goals' },
              isShow: true,
              dataQA: 'sidebar-menu-goals',
              children: [
                {
                  id: 511,
                  name: 'Individual goals',
                  link: { name: 'goals_index', params: { type: 'individual' } },
                  dataQA: 'sidebar-menu-goals-individual',
                },
                {
                  id: 512,
                  name: 'Team goals',
                  link: { name: 'goals_index', params: { type: 'team' } },
                  dataQA: 'sidebar-menu-goals-teams',
                },
                {
                  id: 513,
                  name: 'Organization goals',
                  link: { name: 'goals_index', params: { type: 'organization' } },
                  dataQA: 'sidebar-menu-goals-org',
                },
                {
                  id: 514,
                  name: 'Company goals',
                  link: { name: 'goals_index', params: { type: 'company' } },
                  dataQA: 'sidebar-menu-goals-company',
                },
                {
                  id: 516,
                  name: 'Goal hierarchy',
                  link: { name: 'goals_hierarchy' },
                  dataQA: 'sidebar-menu-goals-hierarchy',
                  badge: 'New',
                  isHidden: !(this.isSuperAdmin || this.isConsultantSA),
                },
                {
                  id: 515,
                  name: 'Settings',
                  link: { name: 'goals_setting' },
                  dataQA: 'sidebar-menu-goals-setting',
                  isHidden: !this.isSuperAdmin,
                },
              ],
            },
            // If doesn't have access to Talent Management menu
            {
              id: 61,
              name: 'Talents',
              icon: 'talent-management',
              link: { name: 'talent_management_landing' },
              isShow: !this.canAccessSuccessionPlan && !this.isKakiTangan,
              badge: 'New',
              dataQA: 'sidebar-menu-talent-management',
              isNeedUpgrade: true,
            },
            // Else if have access Talent Management
            {
              id: 62,
              name: 'Talents',
              icon: 'talent-management',
              link: { name: 'sucession_plan' },
              isShow: this.canAccessSuccessionPlan && this.isSuperAdmin && !this.isKakiTangan,
              dataQA: 'sidebar-menu-talent-management',
              children: [
                {
                  id: 621,
                  name: 'Succession plan',
                  link: { name: 'sucession_plan', params: { tab: 'key-position' } },
                  dataQA: 'sidebar-menu-succession-plan',
                },
                {
                  id: 623,
                  name: 'IDP',
                  link: { name: 'individual_development_plan_index' },
                  dataQA: 'sidebar-menu-idp',
                },
                {
                  id: 624,
                  name: 'Competency',
                  link: { name: 'competency_index' },
                  dataQA: 'sidebar-menu-competencies',
                },
              ],
            },
            {
              id: 63,
              name: 'IDP',
              icon: 'talent-management',
              link: { name: 'individual_development_plan_index' },
              isShow: this.canAccessSuccessionPlan && !this.isSuperAdmin && !this.isKakiTangan,
              dataQA: 'sidebar-menu-idp',
            },
          ],
        },
        {
          isShow: this.isSuperAdmin || this.hasAccess('manage-users') || this.hasAccess('review-setting'),
          items: [
            {
              id: 7,
              name: 'Settings',
              icon: 'settings',
              link: { name: 'settings' },
              isShow: true,
              dataQA: 'sidebar-menu-settings',
            },
          ],
        },
      ];
    },
    subMenus() {
      if (this.$route.path.includes('/reports/')) {
        return {
          submenuTitle: 'Reports',
          submenu: [
            {
              name: 'Review reports',
              link: '/reports/reviews',
              isHidden: !(this.isSuperAdmin || this.hasAccess('review-cycle.report')),
              dataQA: 'sidebar-submenu-report-review',
            },
            {
              name: 'Goal reports',
              link: '/reports/goals',
              isHidden: !this.canAccessGoalReport,
              dataQA: 'sidebar-submenu-report-goals',
            },
            {
              name: '9 Box matrix',
              link: '/reports/nine-box',
              isHidden: !(this.isSuperAdmin || this.hasAccess('review-cycle.report')),
              dataQA: 'sidebar-submenu-report-9box',
              isDisabled: this.isKakiTangan,
            },
          ],
        };
      }
      if (this.$route.path.includes('/reviews/')) {
        return {
          submenuTitle: 'Reviews',
          submenu: [
            {
              name: 'Pending actions',
              link: { name: 'performance_review_root' },
              badge: this.$store.getters.getSidebarNotif('pending_action'),
              dataQA: 'sidebar-submenu-reviews-performance-review',
            },
            {
              name: 'Review cycles',
              link: { name: 'review_cycle_list' },
              isHidden: !(this.isSuperAdmin || this.hasAccess('review-cycle')),
              dataQA: 'sidebar-submenu-reviews-review-cycle',
            },
            {
              name: 'My review',
              link: { name: 'performance_review_my_review' },
              dataQA: 'sidebar-submenu-reviews-my-review',
            },
            {
              name: 'Calibration',
              link: { name: 'calibration_list' },
              dataQA: 'sidebar-submenu-reviews-calibration',
              isHidden: !this.isSuperAdmin && !this.canAccessCalibration,
            },
          ],
        };
      }
      if (this.$route.path.includes('/goals/')) {
        return {
          groups: [
            {
              submenuTitle: 'Goals',
              submenu: [
                {
                  name: 'Individual',
                  link: { name: 'goals_index', params: { type: 'individual' } },
                  dataQA: 'sidebar-submenu-goals-individual',
                },
                {
                  name: 'Team',
                  link: { name: 'goals_index', params: { type: 'team' } },
                  dataQA: 'sidebar-submenu-goals-teams',
                },
                {
                  name: 'Organization',
                  link: { name: 'goals_index', params: { type: 'organization' } },
                  dataQA: 'sidebar-submenu-goals-org',
                },
                {
                  name: 'Company',
                  link: { name: 'goals_index', params: { type: 'company' } },
                  dataQA: 'sidebar-submenu-goals-company',
                },
              ],
            },
            {
              submenuTitle: '',
              isHidden: !(this.isSuperAdmin || this.isConsultantSA),
              submenu: [
                {
                  name: 'Goal hierarchy',
                  link: { name: 'goals_hierarchy' },
                  badge: 'New',
                  isHidden: !(this.isSuperAdmin || this.isConsultantSA),
                },
                {
                  name: 'Goal settings',
                  link: { name: 'goals_setting' },
                  dataQA: 'sidebar-submenu-goals-setting',
                  isHidden: !this.isSuperAdmin,
                },
              ],
            },
          ],
        };
      }
      if (this.isTalentsPages && this.isSuperAdmin && !this.isKakiTangan) {
        return {
          submenuTitle: 'Talents',
          submenu: [
            {
              name: 'Succession plan',
              link: { name: 'sucession_plan', params: { tab: 'key-position' } },
              dataQA: 'sidebar-submenu-succession-plan',
            },
            {
              name: 'IDP',
              link: { name: 'individual_development_plan_index' },
              dataQA: 'sidebar-submenu-idp',
            },
            {
              name: 'Competency',
              link: '/competency-management/',
              children: [
                {
                  name: 'Assignment',
                  link: { name: 'competency_assignment_index' },
                  dataQA: 'sidebar-submenu-assignment',
                },
                {
                  name: 'Competency group',
                  link: { name: 'competency_group_index' },
                  dataQA: 'sidebar-submenu-competency-group',
                },
                {
                  name: 'Competency items',
                  link: { name: 'competency_item_index' },
                  dataQA: 'sidebar-submenu-competency-iten',
                },
                {
                  name: 'Rating Scale',
                  link: { name: 'competency_rating_index' },
                  dataQA: 'sidebar-submenu-rating-scale',
                },
              ],
            },
          ],
        };
      }
      if (this.$route.path.includes('/settings') && (this.isSuperAdmin || this.hasAccess('review-setting') || this.hasAccess('manage-users'))) {
        return {
          submenuTitle: 'Settings',
          submenu: [
            {
              name: 'Manage user',
              link: '/manage-user/',
              isHidden: !(this.isSuperAdmin || this.hasAccess('manage-users')),
              dataQA: 'sidebar-menu-settings-manage-users',
              isDisabled: this.isKakiTangan,
              children: [
                {
                  name: 'Roles',
                  link: '/settings/manage-user/roles',
                  dataQA: 'sidebar-menu-settings-roles',
                  isDisabled: this.isKakiTangan,
                },
                {
                  name: this.$store.getters.getGrantAccess?.isQuotaBased ? 'Add user' : 'Assign roles',
                  link: '/settings/manage-user/assign-role',
                  dataQA: 'sidebar-menu-settings-assign-roles',
                  isDisabled: this.isKakiTangan,
                },
                {
                  name: 'Activity logs',
                  link: '/settings/manage-user/activity-log',
                  isHidden: !this.isSuperAdmin,
                  dataQA: 'sidebar-menu-settings-activity-log',
                  isDisabled: this.isKakiTangan,
                },
              ],
            },
            {
              name: 'Templates',
              link: { name: 'settings_template' },
              isHidden: !(this.isSuperAdmin || this.hasAccess('review-setting')),
              dataQA: 'sidebar-menu-settings-templates',
            },
            {
              name: 'Reminder',
              link: { name: 'settings_reminder' },
              isHidden: !(this.isSuperAdmin || this.hasAccess('review-setting')),
              dataQA: 'sidebar-menu-settings-reminder',
            },
            {
              name: 'Payroll groups',
              link: { name: 'settings_payroll_group' },
              isHidden: !this.isSuperAdmin,
              dataQA: 'sidebar-menu-settings-payroll',
              isDisabled: this.isKakiTangan,
            },
            {
              name: '9 Box configurations',
              link: { name: 'settings_9box' },
              isHidden: !this.isSuperAdmin,
              dataQA: 'sidebar-menu-settings-9box',
              isDisabled: this.isKakiTangan,
            },
          ],
        };
      }
      return '';
    },
    canAccessSuccessionPlan() {
      return this.$store.state.canAccessSuccessionPlan || false;
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeydown);
    this.isStacked = !this.defaultIsToggle ?? false;
    this.isToggle = this.isCollapsed ? this.defaultIsToggle ?? true : this.defaultIsToggle ?? false;
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  mounted() {
    this.$store.commit('SET_SIDEBAR_NOTIF', { pending_action: this.$cookies.get('total-pending-task') }, { root: true });

    this.canAccessCalibration = this.$cookies.get('can-access-calibration') === 'true';
    const canAccessGoalReportCookie = this.$cookies.isKey('can-access-report');
    if (canAccessGoalReportCookie) {
      this.canAccessGoalReport = this.$cookies.get('can-access-report') === 'true';
    } else {
      this.checkGoalReportPermission();
    }
    this.$store.dispatch('checkSuccessionPlanPermission', this.cid);

    // To set collapse/expand sidebar, force collapse/expand button & stack based on default toggle
    this.isToggle = this.defaultIsToggle;
    this.isForced = !this.defaultIsToggle;
    this.isStacked = !this.defaultIsToggle;
  },
  methods: {
    handleMouseEnter() {
      if (!this.preventHover) {
        if (this.isForced) return;

        if (!this.isToggle && this.isCollapsed) this.isToggle = true;
        else this.isToggle = false;
      }
    },
    handleMouseLeave() {
      if (this.isForced) return;

      if (!this.isToggle && this.isCollapsed) this.isToggle = false;
      else this.isToggle = true;

      this.preventHover = false;
    },
    handleToggle() {
      this.isToggle = !this.isToggle;
      this.isForced = !this.isForced;
      if (this.isCustom) {
        this.isToggle = false;
        this.isStacked = !this.isStacked;
      }

      this.handleMouseLeave();
    },
    handleChildToggle(e) {
      this.isChildToggle = e;
    },
    handleKeydown(e) {
      // collapse or expand sidebar using shortcut [shift] + [x]
      if (e.shiftKey && e.keyCode === 88) {
        this.handleToggle();
        this.handleMouseLeave();
      }
    },
    handleHovered(id) {
      this.isHovered = id;
    },
    async checkGoalReportPermission() {
      try {
        const url = `${this.$endPoint}/goals/check-access-report`;
        const { data } = await this.$axios.get(url);

        this.canAccessGoalReport = data?.can_access_report;
        this.$cookies.set('can-access-report', this.canAccessGoalReport);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
